import { useEffect, useState } from "react";
import { Reveal } from "../components/Reveal";
import { fetchTestimonials } from "../lib/api";
import { Quote, User } from "lucide-react";

export default function TestimonialsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    fetchTestimonials()
      .then(setItems)
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="testimonials-page">
      <section className="pt-20 pb-10 md:pt-28 md:pb-16 bg-gradient-to-br from-brand-cream via-brand-bone/30 to-brand-cream">
        <div className="container-editorial">
          <Reveal>
            <div className="max-w-3xl">
              <div className="text-[11px] tracking-[0.24em] uppercase text-brand-rose font-semibold">Testimonials</div>
              <h1 className="mt-3 font-serif text-5xl md:text-6xl lg:text-7xl text-brand-charcoal tracking-tight leading-[1.02]">
                In her own words.
              </h1>
              <p className="mt-6 text-lg text-brand-muted leading-relaxed">
                Real stories from women who walked through our doors and into a new chapter — told the way they
                want to tell them.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="pb-24">
        <div className="container-editorial">
          {loading && <div className="text-center text-brand-muted py-20">Loading…</div>}
          {!loading && items.length === 0 && (
            <div className="text-center bg-white border border-brand-line rounded-3xl py-20 px-6">
              <Quote className="w-10 h-10 text-brand-teal/40 mx-auto" />
              <p className="mt-4 text-brand-muted">Stories are being shared soon. Check back with us.</p>
            </div>
          )}
          {!loading && items.length > 0 && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {items.map((t, i) => {
                const imgSrc = t.image_url
                  ? (t.image_url.startsWith("http") ? t.image_url : `${BACKEND_URL}${t.image_url}`)
                  : null;
                return (
                  <Reveal key={t.id} delay={i * 80}>
                    <article
                      data-testid={`testimonial-${t.id}`}
                      className="h-full bg-white border border-brand-line rounded-3xl p-7 md:p-9 hover:-translate-y-1 hover:shadow-lg transition-all duration-500"
                    >
                      <Quote className="w-7 h-7 text-brand-peach" />
                      <blockquote className="mt-4 font-serif text-xl md:text-2xl text-brand-charcoal leading-snug">
                        “{t.message}”
                      </blockquote>
                      <div className="mt-6 flex items-center gap-4">
                        <div className="w-12 h-12 rounded-full bg-brand-bone overflow-hidden flex items-center justify-center shrink-0">
                          {imgSrc ? (
                            <img src={imgSrc} alt={t.name} className="w-full h-full object-cover" />
                          ) : (
                            <User className="w-5 h-5 text-brand-muted" />
                          )}
                        </div>
                        <div>
                          <div className="font-serif text-lg text-brand-charcoal">{t.name}</div>
                          {t.role && <div className="text-[11px] tracking-[0.2em] uppercase text-brand-rose">{t.role}</div>}
                        </div>
                      </div>
                    </article>
                  </Reveal>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
